export default __webpack_public_path__ + "static/media/coder-one.aec4c223.svg";